var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0742 7.68578L13.5508 10.7608L14.6063 15.3389C14.6621 15.5782 14.6462 15.8287 14.5604 16.059C14.4747 16.2894 14.323 16.4893 14.1242 16.6339C13.9255 16.7784 13.6885 16.8612 13.443 16.8718C13.1975 16.8824 12.9543 16.8204 12.7438 16.6936L8.7508 14.2717L4.76642 16.6936C4.55593 16.8204 4.31272 16.8824 4.06718 16.8718C3.82165 16.8612 3.5847 16.7784 3.38595 16.6339C3.1872 16.4893 3.03548 16.2894 2.94974 16.059C2.86401 15.8287 2.84807 15.5782 2.90392 15.3389L3.95783 10.7655L0.433611 7.68578C0.247212 7.52502 0.112425 7.3128 0.0461548 7.07574C-0.0201157 6.83868 -0.0149204 6.58733 0.0610892 6.35321C0.137099 6.11909 0.280539 5.91262 0.473422 5.7597C0.666305 5.60678 0.900045 5.51421 1.14533 5.49359L5.79064 5.09125L7.60392 0.76625C7.69862 0.53931 7.85834 0.345459 8.06297 0.209108C8.26761 0.0727563 8.50802 0 8.75392 0C8.99983 0 9.24023 0.0727563 9.44487 0.209108C9.64951 0.345459 9.80923 0.53931 9.90392 0.76625L11.7227 5.09125L16.3664 5.49359C16.6117 5.51421 16.8454 5.60678 17.0383 5.7597C17.2312 5.91262 17.3747 6.11909 17.4507 6.35321C17.5267 6.58733 17.5319 6.83868 17.4656 7.07574C17.3993 7.3128 17.2645 7.52502 17.0781 7.68578H17.0742Z",
    fill: "url(#paint0_linear_4_217)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_217",
    x1: 8.75588,
    y1: 0,
    x2: 8.75588,
    y2: 16.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06533A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DB981"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.256fb4e78accdd8c1fea7ffd6ea34581.svg";
export { ForwardRef as ReactComponent };